export default __webpack_public_path__ + "static/prop-bg-2-3b7ef7878131b7a68d74fc0cac2400e0.png";